const state = {
    user : null,
    jwt : null,
}
  
const mutations = {
    setAuth (state, val) {
        state.jwt = val.jwt;
        state.user = val.user;
    },
    clearAuth (state) {
        state.jwt = null;
        state.user = null;
    }
}
  
const actions = {
}
  
export default {
    state,
    mutations,
    actions,
}